import request from "@/utils/request";

export function allPlanApi(params) {
  return request({
    url: "?c=mes&a=plan&do=getall",
    method: "get",
    params
  });
}

export function exportProgressApi(params) {
  return request({
    url: "?c=mes&a=progress&do=export",
    method: "get",
    params
  });
}

export function planListApi(params) {
  return request({
    url: "?c=mes&a=plan&do=list",
    method: "get",
    params
  });
}

export function statMesApi(params) {
  return request({
    url: "?c=mes&a=plan&do=stat",
    method: "get",
    params
  });
}

export function postPlanApi(data) {
  return request({
    url: "?c=mes&a=plan&do=post",
    method: "post",
    data
  });
}

export function imporMesApi(data) {
  return request({
    url: "?c=mes&a=plan&do=add",
    method: "post",
    data
  });
}

export function removeMesApi(data) {
  return request({
    url: "?c=mes&a=plan&do=remove",
    method: "post",
    data
  });
}

export function removeAllMesApi(data) {
  return request({
    url: "?c=mes&a=plan&do=removeall",
    method: "post",
    data
  });
}
